/**
 * @file Shows who last touched content (username stored on page / version rows).
 */
import { Tooltip, Typography } from "@mui/material";

export interface LastModifierIdentity {
  /** Username from the access token, stored as `created_by`. */
  createdBy: string;
}

function displayLabel(createdBy: string): string {
  if (createdBy === "seed-local" || createdBy.startsWith("seed:")) {
    return "Seed content";
  }
  const pipe = createdBy.indexOf("|");
  if (pipe >= 0 && pipe < createdBy.length - 1) {
    return createdBy.slice(pipe + 1);
  }
  return createdBy.length > 28 ? `${createdBy.slice(0, 14)}…${createdBy.slice(-8)}` : createdBy;
}

/**
 * Renders last modifier with optional tooltip when the label is shortened.
 */
export function LastModifiedBy({ user }: { user: LastModifierIdentity }) {
  const label = displayLabel(user.createdBy);
  const inner = (
    <Typography variant="body2" noWrap component="span">
      {label}
    </Typography>
  );
  if (user.createdBy.length > label.length || user.createdBy !== label) {
    return (
      <Tooltip title={user.createdBy} placement="top">
        <span style={{ cursor: "default" }}>{inner}</span>
      </Tooltip>
    );
  }
  return inner;
}
